import { useAuth } from '@ttoss/react-auth';
import { useQuery } from '@tanstack/react-query';
import { useSiflorApi } from '../../providers/SiflorApiProvider/useSiflorApi';
import { useUserTypes } from './useUserTypes';

export type UserFromApi = {
  id: string;
  name: string;
  email: string;
  phoneNumber: string;
  city: string;
  state: string;
  userTypes: {
    type: string;
  };
};

export const useUser = () => {
  const { siflorApi } = useSiflorApi();

  const { user: authUser } = useAuth();

  const { data } = useQuery<{ user: UserFromApi[] }>({
    queryKey: ['getUser', authUser?.id],
    queryFn: ({ queryKey }) => {
      const userId = queryKey[1];

      if (!userId) {
        return Promise.resolve({ user: [] });
      }

      return siflorApi.getUser(userId);
    },
  });

  const { userTypes } = useUserTypes();

  const isProducer = data?.user?.[0]?.userTypes?.type === 'Produtor';

  const user = {
    ...data?.user?.[0],
    userType: userTypes.find((userType) => {
      return userType.type === data?.user?.[0]?.userTypes?.type;
    }),
    isProducer,
    isBuyer: !isProducer,
  };

  delete user.userTypes;

  return { user };
};
